import react, {useState, useRef, useEffect} from 'react';
import { Box, Grid } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import ReactPlayer from "react-player";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {Header} from '../../components/navbar';
import {Footer} from '../../components/footer';

const Aboutus = () => {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const [isPlaying, setIsPlaying] = useState(false);
    const [isVideoReady, setIsVideoReady] = useState(false);
    const playerRef = useRef(null);
    
    const { language, esUrlYoutubeVideo, enUrlYoutubeVideo } = useSelector( state => state.configuration);

    // // Preload del video cuando se monta el componente
    // useEffect(() => {
    //     // const preloadVideo = () => {
    //     //     const video = document.createElement('video');
    //     //     video.src = "https://dlmblob.blob.core.windows.net/dlmcontainer/video/dluna.mp4";
    //     //     video.preload = "auto";
    //     //     video.style.display = "none";
    //     //     document.body.appendChild(video);
            
    //     //     video.onloadeddata = () => {
    //     //         setIsVideoReady(true);
    //     //         document.body.removeChild(video);
    //     //     };
    //     // };

    //     // preloadVideo();

    //     // Cleanup: detener video al salir de la página
    //     return () => {
    //         if (playerRef?.current) {
    //             playerRef.current?.stop();
    //         }
    //         setIsPlaying(false);
    //     };
    // }, []);

    
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isMd = useMediaQuery(theme.breakpoints.down('md'));
    const isXl = useMediaQuery(theme.breakpoints.down('xl'));

    let screenSize = 4;
    if (isSm) screenSize = 1;
    else if (isMd) screenSize = 2;
    else if (isXl) screenSize = 3;

    
    return(
        <>
            <Box sx={{
                top: 0,
                margin: 0,
                padding: 0,
                height: '100%',
                width: '100%',
                backgroundColor: '#313233',
                backgroundImage: "url('/assets/img/generic/fondo-black.svg')",
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}>
                <Grid container>
                    <Grid item size={12}>
                        {/* <Header /> */}
                    </Grid>
                    <Grid item size={12} sx={{
                        height:'100%',
                        width:'100%',
                        paddingTop:'80px',
                    }}>
                        <div style={{
                            margin: 0,
                            padding: 0,
                            border: 0,
                            width: '100%',
                            height: '110px',
                            display: 'block',
                            position: 'absolute',
                            backgroundImage: "url('/assets/img/generic/Roto2.svg')",
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'left',
                            zIndex: 10, 
                        }}></div>
                    </Grid>
                    <Grid item size={12} sx={{
                        height:'100%',
                        width:'100%',
                        paddingTop:'20px',
                    }}>
                        <Box sx={{
                            height:'100%',
                            marginTop:'120px',
                            paddingLeft:'5%',
                            paddingRight:'5%',
                        }}>
                            <div className="text-regular paragraph-container" style={{color:'white'}}>
                                <div className="text-with-image">
                                    <img src='/assets/img/generic/daniel2.jpg' 
                                        className='animate pop delay-2'
                                        style={{
                                            width:(
                                                screenSize===1 ? '45%' : 
                                                    (screenSize===2 ? '45%' : 
                                                        screenSize===3 ? '25%' : '25%' 
                                                    )
                                            ), 
                                            marginTop:'70px',
                                            verticalAlign:'top', 
                                            float:'right', 
                                            margin: '0 0 20px 50px',
                                            borderRadius:'13px',
                                            boxShadow:'5px 5px 5px 5px black'
                                        }} 
                                    />
                                    <Box className={screenSize<=2 ? 'text-subtitle animate pop delay-1' : 'text-title animate pop delay-1'} 
                                        sx={{color:'white'}}>
                                        {t("aboutus.title1")}
                                    </Box>
                                    <p className='animate pop delay-3' style={{textAlign:'justify'}}>
                                        <b>{t("aboutus.title1_1")}</b> {t("aboutus.text1")}
                                    </p>
                                </div>
                            </div>
                            <br />
                            <div className='text-regular animate pop delay-4' style={{color:'white', textAlign:'justify'}}>
                                {t("aboutus.text2")}
                            </div>
                            
                            <Box className={screenSize<=2 ? "text-subtitle2" : "text-title2"} sx={{
                                width:{
                                    sxs:'100%',
                                    xs:'100%',
                                    sm:'100%',
                                    md:'60%',
                                    lg:'60%',
                                    xl:'60%',
                                },
                                marginTop:{
                                    sxs:'50px',
                                    xs:'50px',
                                    sm:'50px',
                                    md:'100px',
                                    lg:'100px',
                                    xl:'100px',
                                },
                                marginBottom:{
                                    sxs:'50px',
                                    xs:'50px',
                                    sm:'50px',
                                    md:'100px',
                                    lg:'100px',
                                    xl:'100px',
                                },
                                fontWeight:'bold',
                                textAlign:'center',
                                color:'white',
                                paddingTop:'20px',
                                paddingBottom:'20px',
                                paddingLeft:'50px',
                                paddingRight:'50px',
                                backgroundColor:'gray',
                                borderRadius:'100px',
                                justifySelf:'center',
                            }}>
                                <div style={{
                                    margin: 0,
                                    padding: 0,
                                    border: 0,
                                    left:0,
                                    // top:350,
                                    width: '100%',
                                    height: '100%',
                                    display: 'none',
                                    position: 'absolute',
                                    backgroundImage: "url('/assets/img/generic/litop.png')",
                                    backgroundSize: '150px 450px',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'left',
                                    zIndex: 0, 
                                }}></div>
                                {t("aboutus.title2")} <br />
                                {t("aboutus.title2_1")}
                                
                            </Box>
                            <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                                <Box className='text-subtitle2' sx={{textAlign:'center', color:'white', width:{
                                    sxs:'95%',
                                    xs:'95%',
                                    sm:'95%',
                                    md:'70%',
                                    lg:'60%',
                                    xl:'60%',
                                }}}>
                                    {t("aboutus.title3")}
                                    <br />
                                    <Box className='text-regular' sx={{color:'white', textAlign:'center', alignSelf:'center'}}>
                                        {t("aboutus.text3")}
                                    </Box>
                                </Box>
                            </div>
                            <div style={{width:'100%', textAlign:'center', zIndex:30}}>
                                {/* https://www.youtube.com/watch?v=oGXOSbrO4UQ" */}
                                {/* https://youtube.com/shorts/kdI4atgV-14?feature=share */}
                                {/* <ReactPlayer
                                    url="https://dlmblob.blob.core.windows.net/dlmcontainer/video/dluna.mp4"
                                    controls={true}
                                    loop={true}
                                    muted={false}
                                    playing={true}
                                    height={600}
                                    width={
                                            screenSize===1 ? '100%' :
                                                (screenSize===2 ? '35%' : 
                                                    (screenSize===3 ? '30%' : '25%')
                                                )}
                                    
                                    style={{
                                        zIndex:5,
                                        marginTop:(
                                            screenSize<=2 ? '50px' : '100px'
                                        ),
                                        justifySelf:'center',
                                        boxShadow:'10px 10px 10px 10px'
                                }}></ReactPlayer> */}


                                <ReactPlayer
                                    url={ language==='es' ? esUrlYoutubeVideo : enUrlYoutubeVideo }
                                    controls={true}
                                    loop={false}
                                    muted={false}
                                    playing={true}
                                    height={500}
                                    width={
                                            screenSize===1 ? '100%' :
                                                (screenSize===2 ? '35%' : 
                                                    (screenSize===3 ? '40%' : '25%')
                                                )}
                                    
                                    style={{
                                        zIndex:5,
                                        marginTop:(
                                            screenSize<=2 ? '50px' : '100px'
                                        ),
                                        justifySelf:'center',
                                        boxShadow:'10px 10px 10px 10px'
                                }}></ReactPlayer>



                                {/* {
                                    isVideoReady && ( */}



                                        {/* <ReactPlayer
                                            ref={playerRef}
                                            url="https://dlmblob.blob.core.windows.net/dlmcontainer/video/dluna.mp4"
                                            controls={true}
                                            loop={true}
                                            muted={false}
                                            playing={isVideoReady && isPlaying}
                                            onReady={() => setIsVideoReady(true)}
                                            onPlay={() => setIsPlaying(true)}
                                            onPause={() => setIsPlaying(false)}
                                            onEnded={() => setIsPlaying(false)}
                                            onError={() => setIsVideoReady(false)}
                                            height={500}
                                            width={
                                                screenSize===1 ? '100%' :
                                                (screenSize===2 ? '35%' : 
                                                (screenSize===3 ? '30%' : '25%')
                                            )}
                                            style={{
                                                zIndex:5,
                                                marginTop: screenSize<=2 ? '50px' : '100px',
                                                justifySelf:'center',
                                                boxShadow:'10px 10px 10px 10px black'
                                            }}
                                        />

                                         */}
                                {/* )} */}
                                {/* {!isVideoReady && (
                                    <div style={{
                                        color: 'white', 
                                        marginTop: '20px',
                                        height: '600px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <div>Cargando video...</div>
                                    </div>
                                )} */}
                            </div>
                            
                            <div style={{
                                    margin: 0,
                                    padding: 0,
                                    border: 0,
                                    right:0,
                                    // top:350,
                                    width: '100%',
                                    height: '100%',
                                    display: screenSize===3 ? 'block' : 'none',
                                    position: 'absolute',
                                    backgroundImage: "url('/assets/img/generic/ldtop.png')",
                                    backgroundSize: '150px 550px',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'right',
                                    zIndex: 2, 
                                }}></div>
                            <Box className='text-subtitle2'
                                sx={{color:'white', justifySelf:'center',
                                    marginTop:{
                                        sxs:'50px',
                                        xs:'50px',
                                        sm:'50px',
                                        md:'100px',
                                        lg:'100px',
                                        xl:'100px',
                                    }
                                }}>
                                {t("aboutus.title4")}
                            </Box>
                            
                            <Box className='text-subtitle2' 
                                sx={{color:'white', marginTop:'50px', marginBottom:'100px', justifySelf:'center', textAlign:'center'}}>
                                <img src='/assets/img/generic/team.png' 
                                            style={{
                                                width:(
                                                    screenSize<=2 ? '85%' : 
                                                        (screenSize===3 ? '65%' : '55%')
                                                ), 
                                            }} 
                                        />
                            </Box>
                            
                        </Box>
                    </Grid>
                    <Grid item size={12}>
                        <Footer />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};


export default Aboutus;